/*
 * A moment as a date field and a time field hold it. The fields speak the
 * browser's local time, which is the user's own: they are read back exactly as
 * typed and become an instant only on the way out.
 */

/** What an `<input type='date'>` holds for this moment. */
export function dayValue(date: Date): string {
  return [date.getFullYear(), pad(date.getMonth() + 1), pad(date.getDate())].join('-');
}

/** What an `<input type='time'>` holds for this moment. */
export function hourValue(date: Date): string {
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** The moment the two fields name together, or null while either is empty or unreadable. */
export function momentOf(day: string, hour: string): Date | null {
  if (!day || !hour) return null;
  const moment = new Date(`${day}T${hour}`);
  return Number.isNaN(moment.getTime()) ? null : moment;
}

function pad(value: number): string {
  return String(value).padStart(2, '0');
}
